import axios from "@/axios";

export default {
  namespaced: true,
  state: {
    loading: false,
    provider: null,
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    provider(state) {
      return state.provider;
    },
  },
  mutations: {
    RESET(state) {
      state.loading = false;
      state.provider = null;
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_PROVIDER(state, payload) {
      state.provider = payload;
    },
  },
  actions: {
    reset({ commit }) {
      commit("RESET");
    },
    fetchProvider({ commit }, providerUuid) {
      return new Promise((resolve, reject) => {
        if (!providerUuid) reject(new Error("No providerUuid"));

        commit("SET_LOADING", true);
        axios
          .get(`/providers/${providerUuid}`)
          .then((response) => {
            commit("SET_PROVIDER", response.data);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          })
          .finally(() => commit("SET_LOADING", false));
      });
    },
    updateProvider({ commit }, provider) {
      if (!provider || !provider.uuid) {
        return null;
      }

      return new Promise((resolve, reject) => {
        axios
          .patch(`/providers/${provider.uuid}`, provider, {
            headers: {
              "Content-Type": "application/merge-patch+json",
            },
          })
          .then((response) => {
            if (response.status === 200) {
              commit("SET_PROVIDER", response.data);
              commit("providers/UPDATE_PROVIDER", response.data, { root: true });
              resolve(response.data);
            } else {
              reject(
                new Error(
                  "The request was successfull, but the received status was not the expected one"
                )
              );
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
